export default function logError(err: unknown) {
  // @TODO: Hook up airbrake or something here
  console.error(err)
}
